/** Maximum number of files that can be uploaded at once on the knowledge page */
export const MAX_UPLOAD_FILES = 5;

/** Minimal employee info used across knowledge components for display */
export interface EmployeeInfo {
  fullName: string;
  imageUrl?: string;
  role?: string;
}

export interface SignalFilters {
  searchQuery: string;
  ownerFilter: string | null;
  severityFilter: number | null;
  statusFilter: string | null;
  categoryFilter: string | null;
  sortBy: 'newest' | 'severity';
}

export const DEFAULT_SIGNAL_FILTERS: SignalFilters = {
  searchQuery: '',
  ownerFilter: null,
  severityFilter: null,
  statusFilter: null,
  categoryFilter: null,
  sortBy: 'newest',
};
